class accountWithRelations {
  constructor(accountId, name, description, unit, concepts, employees) {
    this.accountId = accountId;
    this.name = name;
    this.description = description;
    this.unit = unit;
    this.concepts = concepts;
    this.employees = employees;
  }
  static fromJson({
    cuentaId,
    nombre,
    descripcion,
    unidad,
    conceptos,
    empleados,
  }) {
    return new accountWithRelations(
      cuentaId,
      nombre,
      descripcion,
      unidad,
      conceptos,
      empleados
    );
  }
}
export default accountWithRelations;
